import * as GC from '@grapecity/spread-sheets';
import { IMarketRate } from '@models/beta/marketrate';
import { ICalibrationChange } from '@models/calibrations/calibration-changelog';
import { IFunctionalForm } from '@models/functional-form';
import { CalibrationStatus } from '@models/record-status';
import { isValidDate } from '@shared/dates';
import { colours } from '@shared/spread/spread-settings';

/**
 * Gets the functional form name from the ID
 */
export const getFunctionalForm = (functionalFormNum: number, allFunctionalForms: IFunctionalForm[]): string => {
  const foundFunctionalForm = allFunctionalForms ? allFunctionalForms.find(ff => ff.Index === functionalFormNum) : null;
  return foundFunctionalForm ? foundFunctionalForm.Name : '-';
};

export const getMarketRateNameById = (marketRateId: number, marketRates: IMarketRate[]): string => {
  const marketRate = marketRates ? marketRates.find(mr => mr.MarketRateId === marketRateId) : null;
  return marketRate ? marketRate.MarketRateName : '-';
};

export const getCalibrationColour = (status: CalibrationStatus): string => {
  // ! colours got from _variables.scss
  let calibrationColour = '';
  switch (status) {
    case CalibrationStatus.Active:
      calibrationColour = '#72bf44'; // $green
      break;
    case CalibrationStatus.Inactive:
      calibrationColour = '#ffcd40'; // $yellow
      break;
    case CalibrationStatus.Proposed:
      calibrationColour = `#5e91dd`; // $blue
      break;
    case CalibrationStatus.Rejected:
      calibrationColour = '#d75363'; // $red
      break;
  }
  return calibrationColour;
};

export const getCalibrationRecordStatusBorderColor = (recordStatus: CalibrationStatus) => {
  return new GC.Spread.Sheets.LineBorder(getCalibrationColour(recordStatus), GC.Spread.Sheets.LineStyle.thick);
};

// TODO: Move It to dates.ts
export const getDateForDisplay = (date: Date): string => {
  if (isValidDate(date)) {
    const monthStr = date.toString().substr(4, 3);
    const yearStr = date.toString().substr(11, 4);
    return `${monthStr} ${yearStr}`;
  }
};

// TODO: Move to export config exportColours
export const changeLogColours = {
  HeaderColour: '#2b495e',
  LevelTwoColour: '#eeeeee'
};

export const getChangeLogSummary = (summary: ICalibrationChange[]) => {
  if (summary.length > 0) {
    if (summary.length > 1) {
      return `${summary.length} Changes`;
    } else {
      if (summary[0].property && summary[0].current) {
        return `${summary[0].property} Changed From ${summary[0].previous} To ${summary[0].current}`;
      } else {
        return summary[0].property;
      }
    }
  }

  return '';
};

/**
 * Formats a number to two decimal places
 */
export const formatNumber = (num: number) => {
  return (Math.round(num * 100) / 100).toFixed(4);
};

export const styleRangeBasedOnCalibrationStatus = (range: GC.Spread.Sheets.CellRange, recordStatus: CalibrationStatus) => {
  switch (recordStatus) {
    case CalibrationStatus.Proposed:
      range.backColor(colours.PROPOSED_BG);
      break;
    case CalibrationStatus.Rejected:
      range.backColor(colours.REJECTED_BG);
      break;
    default:
      break;
  }
};
